import axios from "axios";
// import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import store from "../redux/store";
import { accessTokenApi } from "./LiveApi";
import { actions } from "../redux/slices/userSlice";
import { decryptPayload } from "../utils/aes";

const API_BASE_URL = import.meta.env.VITE_BACKEND_API_URL;

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});
axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.getState().userReducer.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  async (response) => {
    if (response.data?.encrypted) {
      const { data, iv } = response.data;
      response.data = await decryptPayload({ data, iv });
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // 1. If we get a 401 and we haven't tried to refresh yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true; // Mark as retried to prevent loops
      isRefreshing = true;
      // originalRequest._retry = true; // Mark as retried to prevent loops

      try {
        const refreshToken = store.getState().userReducer.refreshToken;
        if(!refreshToken){
          return
        }
        const res = await accessTokenApi(refreshToken);

        const newAccessToken = res?.accessToken;
        store.dispatch(actions.setItem(["token", newAccessToken]));

        // return;
        processQueue(null, newAccessToken);
        // Update the header and retry the original request
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);

        // 2. If the refresh token call fails (401 or 403),
        // it means the refresh token is dead. LOG OUT.
        // store.dispatch(actions.logout());

        // Clean up and redirect
        // window.location.href = "/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

const handleRequestError = (error) => {
  if (error.response) {
    if (error.response.status === 422) {
      const errors = error.response.data.data;
      Object.keys(errors).map((key) => toast.error(errors[key][0]));
    }
    let err = {
      errorType: "HTTP Error",
      status: error.response.status,
      message: error.response.data,
      response: "Failure",
    };
    return err;
  } else if (error.request) {
    // Handle network issues (e.g., no internet connection)
    let err = {
      errorType: "Network Error",
      // status: error.response.status,
      message: error.message,
      response: "Failure",
    };
    return err;
  } else {
    // Handle other errors
    console.error("Error:", error.message);
  }
  throw error; // Propagate the error for further handling
};
// GET request function
export const get = async (url, params = {}) => {
  try {
    const response = await axiosInstance.get(url, { params });
    return response.data;
  } catch (error) {
    handleRequestError(error);
  }
};
// POST request function
export const post = async (url, data = {}) => {
  try {
    // console.log("resp", data);
    const response = await axiosInstance.post(url, data);
    if (response) return { data: response.data, response: "Success" };
  } catch (error) {
    // console.log("error occured", error)
    // return handleRequestError(error);
  }
};
// PUT request function
export const put = async (url, data = {}) => {
  try {
    const response = await axiosInstance.put(url, data);
    return response.data;
  } catch (error) {
    handleRequestError(error);
  }
};
// PATCH request function
export const patch = async (url, data = {}) => {
  try {
    const response = await axiosInstance.patch(url, data);
    return response.data;
  } catch (error) {
    handleRequestError(error);
    throw new Error("Request Error");
  }
};
// DELETE request function
export const del = async (url) => {
  try {
    const response = await axiosInstance.delete(url);
    return response.data;
  } catch (error) {
    handleRequestError(error);
  }
};
// POST with files
// export const postFiles = async (url, data, method) => {
//   method = method ? method : "POST";
//   try {
//     const response = await fetch(`${API_BASE_URL}${url}`, {
//       method: method,
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       body: data,
//     });
//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }
//     const responseData = await response.json();
//     return { data: responseData, response: "Success" };
//   } catch (error) {
//     return handleRequestError(error);
//   }
// };